import React, { ReactNode, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole: string; 
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { instance, inProgress } = useMsal();
  const navigate = useNavigate();

  /**
   * If user doesn't have Admin role he will be redirected to home screen.
   */
  useEffect(() => {
    const activeAccount = instance.getActiveAccount();
    if (
      inProgress === InteractionStatus.None &&
      (!activeAccount || !(activeAccount.idTokenClaims?.roles || []).includes(requiredRole))
    ) {
      console.error("User is not authorized to access this route. Redirecting to home.");
      navigate("/", { replace: true });
    }
  }, [instance, inProgress, requiredRole, navigate]);

  if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
    return <div>Loading authentication...</div>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;